import { ConfigureHooks } from '../models';

export const pluginStore: Record<string, ConfigureHooks> = {};
